import { ButtonType } from '../GenericButton/styles'
import GenericModal from '../GenericModal'
import React, { useEffect } from 'react'
import theme from '../../theme'
import { useBlocker } from 'react-router-dom'

interface BlockerProps {
  isDirty?: boolean
  storeKey: string
  children?: React.ReactNode
  title?: string
  confirmActionText?: string
}

const UnsavedBlockerModal: React.FC<BlockerProps> = ({
  isDirty,
  storeKey,
  children,
  title,
  confirmActionText
}): JSX.Element => {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (process.env.NODE_ENV === 'development') console.log('Blocking reason:', isDirty ? 'dirty' : localStorage.getItem(storeKey) !== null ? 'local save' : 'none')
    const isDifferentLocation = currentLocation.pathname !== nextLocation.pathname
    const isBlocked = blocker?.state === 'blocked'
    const localStorageItemExists = localStorage.getItem(storeKey) !== null
    return (isDifferentLocation && isBlocked) || (isDirty ?? false) || localStorageItemExists
  })

  // set up event listeners for page resets
  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
    event.preventDefault()
    event.returnValue = true // keep for legacy browser support
  }

  const handleDontSaveClicked = (): void => {
    localStorage.removeItem(storeKey)
    blocker?.proceed?.()
  }

  return (
    <GenericModal
      isOpen={blocker?.state === 'blocked'}
      onClose={() => { blocker?.reset?.() }}
      onConfirm={async () => { handleDontSaveClicked() }}
      title={title ?? 'Unsaved Changes'}
      confirmActionText={confirmActionText ?? "Don't Save"}
      confirmActionType={ButtonType.Destructive}
      destructiveButtonText='Cancel'
      destructiveButtonType={ButtonType.Secondary}
      modalWidth={theme.spacing(100)}
    >
      {children ?? 'You have unsaved changes. Are you sure you want to leave this page?'}
    </GenericModal>
  )
}

export default UnsavedBlockerModal
